const fragment = `
precision highp float;

uniform vec3 uResolution;

uniform sampler2D uCameraTexture;

varying mat4 vProjectionMatrix;

uniform mat4 uCameraWorldMatrixInverse;

varying vec2 vUv;

uniform mat4 uImageTrackerWorldMatrix;

uniform float uUvMultiplierX;
uniform float uUvMultiplierY;

uniform float uUvOffsetX;
uniform float uUvOffsetY;

// ~Light~
// varying vec3 vecPos;
// varying vec3 vecNormal;

// uniform float lightIntensity;

// struct PointLight {
//   vec3 color;
//   vec3 position;  // light position, in camera coordinates
//   float distance; // used for attenuation purposes. Since
//                   // we're writing our own shader, it can
//                   // really be anything we want (as long
//                   // as we assign it to our light in its
//                   // "distance" field
// };
 
// uniform PointLight pointLights[NUM_POINT_LIGHTS];

void main()	{
  // Light
  // Pretty basic lambertian lighting...
  // vec4 addedLights = vec4(0.0, 0.0, 0.0, 1.0);

  // for(int l = 0; l < NUM_POINT_LIGHTS; l++) {
  //     vec3 lightDirection = normalize(vecPos - pointLights[l].position);
  //     addedLights.rgb += clamp(dot(-lightDirection, vecNormal), 0.0, 1.0) * pointLights[l].color * lightIntensity;
  // }

  vec4 uv4 = vec4(vUv.x, vUv.y, 0, 1);

  uv4.x = (uv4.x - 0.5) * 2.0 * uUvMultiplierX;
  uv4.x += uUvOffsetX;
  uv4.y += uUvOffsetY;
  uv4.y = (uv4.y - 0.5) * 2.0 * uUvMultiplierY;

  uv4.y = 1.0 - uv4.y;

  mat4 imageTrackerWorldMatrix = uImageTrackerWorldMatrix;

  vec4 clipCoords = vProjectionMatrix * uCameraWorldMatrixInverse * imageTrackerWorldMatrix * uv4;

  clipCoords = clipCoords / clipCoords.w;
  clipCoords.x = (clipCoords.x * 0.5) + 0.5;
  clipCoords.y = (clipCoords.y * 0.5) + 0.5;

  vec4 texture = texture2D(uCameraTexture, clipCoords.xy); //* addedLights;
  vec3 c = texture.rgb;

  gl_FragColor = vec4(c, 1.0);
}
`

export default fragment
